<template>
  <div class="help">
    <Header></Header>
    <main>
      <div class="head">
      </div>
      <div class="table">
        <div class="clearfix operation">
          <div class="left title">
            <span>帮助文档</span>
          </div>
        </div>
        <!--<div class="clearfix file-list">
          <el-table
            size="medium"
            :data="helpData"
            :show-header="false">
            <el-table-column
              prop="tips"
              label="加密日期"
              min-width="150"
              :show-overflow-tooltip="true">
            </el-table-column>
          </el-table>
        </div>-->
      </div>
      <!--<button  class="submit" @click="submit">登录并发测试</button>
      <button  class="submit" @click="submit">上传并发测试</button>
      <button  class="submit" @click="submit">并发测试</button>-->
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { userLogin } from '@/common/http/server'
import {
  Table,
  TableColumn,
  Dialog,
  Button,
  Radio,
  Tabs,
  TabPane,
  Checkbox,
  DatePicker,
  Input,
  Upload,
  Collapse,
  CollapseItem,
  Message
} from 'element-ui'

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Dialog)
Vue.use(Button)
Vue.use(Radio)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Checkbox)
Vue.use(DatePicker)
Vue.use(Input)
Vue.use(Upload)
Vue.use(Collapse)
Vue.use(CollapseItem)

export default {
  name: 'homepage',
  components: { Header, Footer },
  data () {
    return {
      hasAccountBtn: true,
      userName: '张三',
      department: 'XX科技集团信息化建设中心终端管理组',
      uploadSuccess: false,
      fileList: [],
      todayDate: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate()
      },
      tableDataCache: [],
      tableData: [],
      multipleTable: [],
      pagination: {
        currentPage: 1,
        totalPage: 1
      },
      dialogEncodeVisible: false,
      tabPosition: 1,
      encodeSingleTable: null,
      operationSingleData: {},
      encodeId: 0,
      isMultiple: false,
      encodeTableData: [
        {
          modelName: '001-XX集团全体阅读权限',
          description: '集团全体员工可以阅读文档，但是不能复制、修改、打印等'
        }
      ],
      encodeRecordData: [
        {
          fileName: '001-加密测试文档.doc',
          description: '集团全体员工可以阅读文档，但是不能复制、修改、打印等',
          encodeDate: '2018-12-01'
        }
      ],
      presetWay: 1,
      customWay: 0,
      canEditDoc: false,
      contactWay: '1',
      allowPrint: false,
      allowSetIndate: false,
      allowContactAuthor: false,
      indate: new Date(),
      dialogRecordVisible: false,
      canDel: true,
      canDown: true,
      canEncode: true,
      helpData: [
        // {tips: '1、主页空白，请上传文件'},
        // {tips: '2、文件需要加密才能启用下载功能'},
        // {tips: '3、删除加密记录中的文件，主页中相应的文件也会一并删除，请注意'},
        // {tips: '4、进行批量操作时，请先勾选至少一个文件，再点击左下方批量操作按钮'},
        // {tips: '5、每一行左侧的操作按钮是快捷操作，直接点击即可进行相应操作'}
      ],

      logintest:[
        {user:'rmstest01',pwd:'1234567a'},
        {user:'rmstest02',pwd:'1234567a'},
        {user:'rmstest03',pwd:'1234567a'},
        {user:'rmstest04',pwd:'1234567a'},
        {user:'rmstest05',pwd:'1234567a'},
        {user:'rmstest06',pwd:'1234567a'},
        {user:'rmstest07',pwd:'1234567a'},
        {user:'rmstest08',pwd:'1234567a'},
        {user:'rmstest09',pwd:'1234567a'},
        {user:'rmstest10',pwd:'1234567a'},
        {user:'rmstest11',pwd:'1234567a'},
        {user:'rmstest12',pwd:'1234567a'},
        {user:'rmstest13',pwd:'1234567a'},
        {user:'rmstest14',pwd:'1234567a'},
        {user:'rmstest15',pwd:'1234567a'},
        {user:'rmstest16',pwd:'1234567a'},
        {user:'rmstest17',pwd:'1234567a'},
        {user:'rmstest18',pwd:'1234567a'},
        {user:'rmstest19',pwd:'1234567a'},
        {user:'rmstest20',pwd:'1234567a'}
      ]


    }
  },
  created () {
    this.tableDataCache = this.getLocalStorage('cache')
  },
  mounted () {
  },
  watch: {
    // 侦听展示列表数据，控制下方加密、下载、删除三个按钮是否禁用
    tableData: {
      handler: function (val) {
        this.canDel = !(this.tableData.length > 0)
        this.canDown = this.include(this.tableData, 'isEncode', '已加密')
        this.canEncode = this.include(this.tableData, 'isEncode', '待加密')
      },
      deep: true,
      immediate: true
    },
    // 侦听总缓存的文档页，控制分页器的总页数
    tableDataCache: {
      handler: function () {
        let p
        let start = 9
        let end = 0
        start *= (this.pagination.currentPage - 1)
        end = start + 9
        this.tableData = this.tableDataCache.slice(start, end)
        if (this.tableDataCache.length < 10) {
          p = 1
        } else {
          p = Math.ceil(this.tableDataCache.length / 9)
        }
        this.pagination.totalPage = p
      },
      deep: true,
      immediate: true
    },
    // 侦听分页器数据，用来控制展示页内容。为了展示产品，无实际意义
    pagination: {
      handler: function () {
        let start = 9
        let end = 0
        start *= (this.pagination.currentPage - 1)
        end = start + 9
        this.tableData = this.tableDataCache.slice(start, end)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submit () {
    let submitData = {
        user: this.userName,
        password: this.password
      }
      userLogin({data:submitData})
    },
  


    init (index, row) {
      let start = 9
      let end = 0
      start *= (this.pagination.currentPage - 1)
      end = start + 9
      this.tableData = this.tableDataCache.slice(start, end)
    },
    uploadDeaflt (r, f, fl) {
      console.log(r)
      console.log(f)
      console.log(fl)
      this.fileList = [f]
      this.addTableDataCache()      
    },
    handleSelectionChange (val) {
      this.multipleTable = val
    },
    handleDeleteSingle (index) {
      let item = this.tableData[index]
      let cache = this.getLocalStorage('cache')
      let record = this.getLocalStorage('record')
      this.isMultiple = false
      if (!this.isMultiple) {
        for (let i = 0; i < this.tableDataCache.length; i++) {
          if (this.tableDataCache[i].id === item.id) {
            this.tableDataCache.splice(i, 1)
            cache.splice(i, 1)
          }
        }
        this.setLocalStorage('cache', cache)

        for (let j = 0; j < record.length; j++) {
          if (record[j].id === item.id) {
            record.splice(j, 1)
          }
        }
        this.setLocalStorage('record', record)
      }
    },
    handleDeleteMultiple () {
      let items = this.multipleTable
      let tempCache = []
      let tempRecord = []
      let record = this.getLocalStorage('record')
      this.isMultiple = true
      for (let i = 0; i < this.tableDataCache.length; i++) {
        if (!this.arraySome(items, this.tableDataCache[i].id)) {
          tempCache.push(this.tableDataCache[i])
        }
      }
      this.$set(this.$data, 'tableDataCache', tempCache)
      this.setLocalStorage('cache', tempCache)

      for (let j = 0; j < record.length; j++) {
        if (!this.arraySome(items, record[j].id)) {
          tempRecord.push(record[j])
        }
      }
      this.setLocalStorage('record', tempRecord)
    },
    encodeWayChange (val) {
      this.tabPosition = val
    },
    downloadFile () {
      if (this.multipleTable.length == 0) {
        Message.error({
            message: "请选择要下载的文档"
          });       
      }
    },
    handleSingleChange (val) {
      this.encodeSingleTable = val
    },
    handleEncode () {
      let item = this.operationSingleData
      let items = this.multipleTable
      let tempFileName = ''
      let tempFileEncode = ''
      let id = ''
      let reg = /(?=\.\w+$)/g
      let record = this.getLocalStorage('record') || []
      let cache = this.getLocalStorage('cache')
      if (this.encodeSingleTable) {
        this.dialogEncodeVisible = false
      } else {
        Message.error({
            message: "请选择其中一个模板名称或自定义一个加密方案"
          });        
      }
      if (!this.isMultiple) {
        for (let i = 0; i < this.tableDataCache.length; i++) {
          if (this.tableDataCache[i].id === item.id && this.tableDataCache[i].isEncode === '待加密') {
            tempFileName = item.fileName
            tempFileEncode = tempFileName.replace(reg, '_加密')
            id = item.id
            record.push({
              fileName: tempFileName,
              fileEncode: tempFileEncode,
              isEncode: '已加密',
              date: new Date().toLocaleDateString(),
              id: id
            })
            this.$set(this.$data.tableDataCache[i], 'isEncode', '已加密')
            this.$set(this.$data.tableDataCache[i], 'fileEncode', tempFileEncode)

            cache[i] = {
              fileName: tempFileName,
              fileEncode: tempFileEncode,
              isEncode: '已加密',
              date: new Date().toLocaleDateString(),
              id: id
            }
            this.setLocalStorage('cache', cache)
          }
        }
      } else {
        for (let i = 0; i < this.tableDataCache.length; i++) {
          for (let j = 0; j < items.length; j++) {
            if (this.tableDataCache[i].id === items[j].id && this.tableDataCache[i].isEncode === '待加密') {
              tempFileName = items[j].fileName
              tempFileEncode = tempFileName.replace(reg, '_加密')
              id = items[j].id
              record.push({
                fileName: tempFileName,
                fileEncode: tempFileEncode,
                isEncode: '已加密',
                date: new Date().toLocaleDateString(),
                id: id
              })
              this.$set(this.$data.tableDataCache[i], 'isEncode', '已加密')
              this.$set(this.$data.tableDataCache[i], 'fileEncode', tempFileEncode)

              cache[i] = {
                fileName: tempFileName,
                fileEncode: tempFileEncode,
                isEncode: '已加密',
                date: new Date().toLocaleDateString(),
                id: id
              }
              this.setLocalStorage('cache', cache)
            }
          }
        }
      }

      this.setLocalStorage('record', record)
    },
    addTableDataCache () {
      let result = this.getLocalStorage('cache') || []
      let source = this.fileList
      let tempFileName = ''
      for (let i = 0; i < source.length; i++) {
        tempFileName = source[i].name
        result.push({
          fileName: tempFileName,
          fileEncode: '',
          isEncode: '待加密',
          id: new Date().getTime() + '_' + this.encodeId++
        })
      }
      this.setLocalStorage('cache', result)
      this.$set(this.$data, 'tableDataCache', result)
      this.init()
    },
    handleEncodeSingle (index) {
      let selection = this.tableData[index]
      this.$set(this.$data, 'operationSingleData', selection)
      this.isMultiple = false
      this.dialogEncodeVisible = true
    },
    handleEncodeMultiple () {
      this.isMultiple = true
      this.dialogEncodeVisible = true
    },
    // 功能函数
    include (arr, key, val) {
      let len = arr.length
      for (let i = 0; i < len; i++) {
        if (arr[i][key] === val) {
          return false
        }
      }
      return true
    },
    getLocalStorage (name) {
      let myStorage = window.localStorage
      let result = myStorage.getItem(name)
      return JSON.parse(result)
    },
    setLocalStorage (name, val) {
      let myStorage = window.localStorage
      myStorage.setItem(name, JSON.stringify(val))
    },
    arraySome (arr, id) {
      for (let item of arr) {
        if (item.id === id) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
  .clearfix {
    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  }

  // vue自定义过渡动画，适用于v-show
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  // 单独修改element-ui样式，一般不建议这样做
  .el-table__body tr.current-row>td {
    background-color: rgb(176, 210, 245);
  }
  .el-table__body tr.current-row:hover>td {
    background-color: rgb(176, 210, 245);
  }
  .help {
    // height: 100vh;
    position: relative;
    main {
      margin: 0 42px;
      .head {
        height: 40px;
        font-size: 14px;
        position: relative;
        margin-top: 10px;
        .user>div, .depart>div {
          height: 26px;
        }
        .account {
          font-size: 20px;
          color: #1a197e;
        }
      }

      //列表
      .table {
        .operation {
          margin: 10px 0;
          .title {
            span {
              display: block;
              margin-left: 40px;
              font-size: 16px;
              padding: 5px 0;
              color: #323232;
              position: relative;
            }
          }
          .options {
            span {
              display: block;
              padding: 5px 5px;
              color: #a1a0a0;
              margin-left: 10px;
              -webkit-touch-callout: none;
              -webkit-user-select: none;
              -khtml-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              user-select: none;
              &:hover {
                cursor: pointer;
                text-decoration: underline;
              }
            }
            .active {
              color: blue;
            }
          }
        }
        .file-list {
          tbody {
            min-height: 477px;
          }
          .pagination {
            margin-top: 20px;
            // span {
            //   color: #969696;
            //   margin-left: 10px;
            //   &:not(:last-child):hover {
            //     cursor: pointer;
            //     color: blue;
            //   }
            // }
          }
          .options {
            margin-top: 20px;
            span {
              display: block;
              border-radius: 5px;
              color: #fff;
              -webkit-touch-callout: none;
              -webkit-user-select: none;
              -khtml-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              user-select: none;
            }
            .upload {
              background: #43c92d;
              margin-right: 10px;
            }
            .encode {
              background: #ffae44;
              &:disabled {
                background: rgb(161, 161, 161);
              }
            }
            .download {
              background: #4486ff;
              &:disabled {
                background: rgb(161, 161, 161);
              }
            }
            .delete {
              background: #fe5000;
              &:disabled {
                background: rgb(161, 161, 161);
              }
            }
          }
        }
      }
    }
    .foot {
      margin-top: 40px;
      width: 100%;
      bottom: 0;
    }
    .encode-dialog-container {
      .encode-way {
        margin: 0 0 20px 0;
      }
      .panel {
        .preset-way {
          .preset-way-foot {
            margin-top: 20px;
          }
        }
        .custom-way {
          .custom-way-container {
            font-size: 14px;
            .permission {
              margin-left: 23px;
              border: 1px solid #ccc;
              box-shadow: 0px 2px 3px #ccc;
              min-width: 400px;
              .read-permission {
                height: 300px;
                width: 240px;
                border-right: 1px solid #ccc;
                span {
                  display: block;
                  height: 39px;
                  line-height: 39px;
                  padding-left: 10px;
                  background-color: #f5f7fa;
                  border-bottom: 1px solid #ccc;
                }
                .content {
                  padding: 10px;
                }
              }
              .edit-permission {
                height: 300px;
                width: 240px;
                .title {
                  display: block;
                  height: 39px;
                  line-height: 39px;
                  padding-left: 10px;
                  background-color: #f5f7fa;
                  border-bottom: 1px solid #ccc;
                }
                .content {
                  padding: 10px;
                }
              }
            }
            .company-structure {
              width: 405px;
              height: 300px;
              .content {
                height: 230px;
                .list {
                  height: 200px;
                }
              }
            }
            .quanxian {
              margin-top: 15px;
              .contact {
                margin: 15px 0;
                input {
                  width: 220px;
                  height: 28px;
                  line-height: 30px;
                  border: 1px solid #ccc;
                  border-radius: 5px;
                  padding-left: 5px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/help.vue